/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Change_Applied_B_To_AInputs */

const en_compare_event_groups_change_applied_b_to_a = /** @type {(inputs: Compare_Event_Groups_Change_Applied_B_To_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change applied from Group B to Group A`)
};

const fr_compare_event_groups_change_applied_b_to_a = /** @type {(inputs: Compare_Event_Groups_Change_Applied_B_To_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modification appliquée du groupe B au groupe A`)
};

const de_compare_event_groups_change_applied_b_to_a = /** @type {(inputs: Compare_Event_Groups_Change_Applied_B_To_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderung von Gruppe B auf Gruppe A angewendet`)
};

const it_compare_event_groups_change_applied_b_to_a = /** @type {(inputs: Compare_Event_Groups_Change_Applied_B_To_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifica applicata dal Gruppo B al Gruppo A`)
};

const ru_compare_event_groups_change_applied_b_to_a = /** @type {(inputs: Compare_Event_Groups_Change_Applied_B_To_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменение внесено из группы B в группу A.`)
};

const es_compare_event_groups_change_applied_b_to_a = /** @type {(inputs: Compare_Event_Groups_Change_Applied_B_To_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambio aplicado del Grupo B al Grupo A`)
};

const zh_cn2_compare_event_groups_change_applied_b_to_a = /** @type {(inputs: Compare_Event_Groups_Change_Applied_B_To_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从B组变更至A组`)
};

const ja_compare_event_groups_change_applied_b_to_a = /** @type {(inputs: Compare_Event_Groups_Change_Applied_B_To_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループBからグループAへの変更`)
};

const hi_compare_event_groups_change_applied_b_to_a = /** @type {(inputs: Compare_Event_Groups_Change_Applied_B_To_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समूह B से समूह A में परिवर्तन लागू किया गया`)
};

const pt_pt2_compare_event_groups_change_applied_b_to_a = /** @type {(inputs: Compare_Event_Groups_Change_Applied_B_To_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alteração aplicada do Grupo B para o Grupo A`)
};

/**
* | output |
* | --- |
* | "Change applied from Group B to Group A" |
*
* @param {Compare_Event_Groups_Change_Applied_B_To_AInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_change_applied_b_to_a = /** @type {((inputs?: Compare_Event_Groups_Change_Applied_B_To_AInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Change_Applied_B_To_AInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_change_applied_b_to_a(inputs)
	if (locale === "de") return de_compare_event_groups_change_applied_b_to_a(inputs)
	if (locale === "it") return it_compare_event_groups_change_applied_b_to_a(inputs)
	if (locale === "ru") return ru_compare_event_groups_change_applied_b_to_a(inputs)
	if (locale === "es") return es_compare_event_groups_change_applied_b_to_a(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_change_applied_b_to_a(inputs)
	if (locale === "ja") return ja_compare_event_groups_change_applied_b_to_a(inputs)
	if (locale === "hi") return hi_compare_event_groups_change_applied_b_to_a(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_change_applied_b_to_a(inputs)
	return en_compare_event_groups_change_applied_b_to_a(inputs)
});